import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/seats/holdToken.ts
import { Exception } from "@wbk/logger";
import { getLocaleOnly } from "@wbk/utils";
var getHoldToken = (_0) => __async(void 0, [_0], function* ({ event_id, season_id, locale = "en" }) {
  var _a;
  try {
    const lang = getLocaleOnly(locale);
    const url = `/seats/hold-token?lang=${lang}`;
    const payload = __spreadProps(__spreadValues(__spreadValues({}, event_id ? { event_id } : {}), season_id ? { season_id } : {}), {
      lang
    });
    const data = yield fetchClient({
      url,
      options: {
        method: "POST",
        body: JSON.stringify(payload)
      }
    });
    if (data.status !== "success") {
      throw new Error(((_a = data == null ? void 0 : data.error) == null ? void 0 : _a.message) || (data == null ? void 0 : data.message) || "Something went wrong");
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      name: "getHoldTokenException",
      error
    });
  }
});

export {
  getHoldToken
};
//# sourceMappingURL=chunk-PVKP426M.mjs.map